<script setup lang="ts">
const site = useSite()
</script>

<template>
  <section
    class="flex w-full flex-row items-center justify-between gap-8 bg-mcd-main py-8 pl-8 pr-16"
  >
    <div class="flex w-full gap-8">
      <!-- TODO quitar comentario cuando la imagen de mercado sea la correcta -->
      <!-- <figure class="relative w-[290px] md:hidden xl:block"> 
        <img
          class="absolute -bottom-5"
          :src="site.footer?.downloadSection.image?.url"
          :alt="site.footer?.downloadSection.image?.alternativeText || undefined"
        />
      </figure> -->

      <div class="flex flex-col gap-2 leading-8 tracking-[-0.15px] md:text-xl lg:text-2xl">
        <p>
          {{ site.footer?.downloadSection.title }}
        </p>
        <p class="font-bold">
          {{ site.footer?.downloadSection.description }}
        </p>
      </div>
    </div>

    <div v-if="site.footer?.downloadSection.button" class="flex items-center justify-center">
      <SimpleLink :link="site.footer?.downloadSection.button">
        <McdButton
          class="w-[202px] rounded border-[1px] border-slate-950 bg-slate-100 px-[2.63rem] py-3 text-sm font-bold leading-4 tracking-[-0.15px]"
        >
          {{ site.footer?.downloadSection.button?.title }}
        </McdButton>
      </SimpleLink>
    </div>
  </section>
</template>
